<template>
  <div
    v-if="entity"
    class="grid_item_container pointer"
    @click="showItem()"
    @mouseenter="onMouseOver = true"
    @mouseleave="onMouseOver = false"
  >
    <img
      v-lazy-load :data-src="entity.image"
      class="image"
    >
    <div v-if="onMouseOver && !$device.isMobileOrTablet" class="overlay" />
    <img v-if="onMouseOver && !$device.isMobileOrTablet" class="more" v-lazy-load data-src="/more.svg" @click.stop="showItemMenu()">
    <PopupDialog :item="entity" :type="'user'" class="item_context_menu" />
    <div v-if="onMouseOver && !$device.isMobileOrTablet" class="counters">
      <div v-title="'Followers'" class="badge">
        <img v-lazy-load data-src="/heart.png">{{ entity.followersCount }}
      </div>
      <!--      <div class="badge" v-title="'purchased by users'">-->
      <!--        <img v-lazy-load data-src="/cart.svg">{{ entity.gotitCount }}-->
      <!--      </div>-->
    </div>
    <div class="bottom">
      <div class="item_name">
        <div class="user_name">
          {{ entity.username.substring(0, 48) }}
        </div>
        <div class="name">
          {{ entity.name.substring(0, 48) }}
        </div>
      </div>
      <button v-if="$store.state.localStorage.currentUser.id > 0" class="btns-gray-embo wantit pointer" @click.stop="onFollowClick()">
        {{ entity.extra.isFollowed === 'true' ? '+ Unfollow' : '+ Follow' }}
      </button>
    </div>
    <div class="middle" />
  </div>
</template>

<script>
import AbstractComponent from './AbstractComponent'
import PriceButton from './PriceButton'
import PopupDialog from './PopupDialog'
import utils from '~/mixins/utils'

export default {
  name: 'GridStoreComponent',
  // eslint-disable-next-line vue/no-unused-components
  components: { PopupDialog, PriceButton },
  extends: AbstractComponent,
  mixins: [utils],
  data () {
    return {
      onMouseOver: false
    }
  },
  computed: {
  },
  beforeMount () {
    this.bucketName = 'users'
  },
  mounted () {
  },
  methods: {
    showItemMenu () {
      this.$root.$emit('background_clicked')
      setTimeout(() => {
        this.$root.$emit('show_popup_dialog' + this.entity.id, this.entity)
      }, 50)
    },
    showItem () {
      /* if (this.$device.isMobileOrTablet) {
        return
      } */
      const user = this.getUser(this.entityId)
      let path = ''
      if (user.store) {
        path = '/stores/' + this.encrypt(user.id)
      } else {
        path = '/users/' + this.encrypt(user.id)
      }
      switch (this.$route.name) {
        case 'search':
          this.$emit('navigate', path)
          break
        default:
          this.$router.push({
            path
          })
          break
      }
    },
    getUser (userId) {
      return this.$store.state.api.buckets.users[userId]
    },
    async onFollowClick () {
      let isFollowed = 'true'
      if (this.entity.extra.isFollowed === 'true') {
        isFollowed = 'false'
      }
      this.$emit('followStateChanged', isFollowed)
      const params = {
        id: this.entity.id,
        typeParam: isFollowed,
        type: 'FOLLOW'
      }
      await this.$store.dispatch('api/userExecute', params)
      this.$store.dispatch('api/followEvent', {
        isFollowed
      }).then().catch()
    }
  }
}
</script>

<style scoped>
  .grid_item_container {
    position: relative;
    width: 300px;
    height: 360px;
    border-radius: 10px;
    box-shadow: 0px 0px 3px rgba(127, 130, 139, 0.29);
    border-collapse: separate;
    overflow: hidden;
  }

  .mobile_design .grid_item_container {
    width: 150px;
    height: 150px;
    border-radius: unset;
  }

  .mobile_design .user .grid_item_container {
    width: unset;
    height: 50px;
    padding: 0.5em;
    display: flex;
    align-content: center;
    align-items: center;
  }

  .image {
    width: 100%;
    opacity: 1;
    transition: .5s ease;
    backface-visibility: hidden;
    position: absolute;
  }

  .mobile_design .user .image {
    width: calc(50px - 0.5em);
    height: calc(50px - 0.5em);
    margin-left: 0.5em;
    margin-top: 0.25em;
    border-radius: 50%;
  }
  .carusel_item {
    position:absolute;
    left:0;
    -webkit-transition: opacity 1s ease-in-out;
    -moz-transition: opacity 1s ease-in-out;
    -o-transition: opacity 1s ease-in-out;
    transition: opacity 1s ease-in-out;
  }

  .middle {
    transition: .5s ease;
    opacity: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    text-align: center;
  }

  .carusel_item {
    opacity: 0;
  }

  /* .grid_item_container:hover .image {
    opacity: 0;
  } */

  .grid_item_container:hover .middle {
    opacity: 1;
  }

  .text {
    background-color: #f61948;
    color: white;
    font-size: 16px;
    padding: 16px 32px;
  }

  .carusel {
    position: relative;
  }

  img {
    position: relative;
    top: 0;
    left: 0;
  }

  .images_indicator {
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: center;
    position: relative;
    bottom: 140px;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
  }

  .images_indicator div {
    height: 10px;
    width: 10px;
    background-color: white;
    border: 2px solid red;
    border-radius: 50%;
    align-self: flex-end;
    margin: 0.3em;
  }

  .current_indicator {
    background-color: black !important;
  }

  .bottom {
    background-color: white;
    position: relative;
    display: flex;
    align-items: center;
    padding-left: 1em;
    padding-right: 1em;
    top: 300px;
    height: 60px;
  }

  .mobile_design .user .bottom {
    position: unset;
    top: unset;
    height: unset;
    margin-left: calc(0.25em + 50px);
    flex-grow: 1;
  }

  .item_name {
    flex-grow: 1;
    margin-right: 1em;
  }

  .user_name {
    display: none;
  }

  .mobile_design .user_name {
    display: unset;
  }

  .mobile_design .item_name {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }

  .mobile_design .item_name .name {
    color: #a09e9e;
  }

  .price_button {
    background-color: white;
    white-space: nowrap;
    font-size: 12px;
    border: 1px solid #ed4956;
    border-radius: 15px;
    padding: 1px 6px;
    flex-grow: unset;
  }

  .overlay {
    height: 300px;
    width: 300px;
    position: absolute;
    background-color: rgba(77, 78, 84, 0.33);
  }

  .more {
    width: 30px;
    position: absolute;
    right: 0;
    background-color: white;
    border-radius: 50%;
    padding: 0.4em;
    top: 255px;
    left: 260px;
    z-index: 15000;
    box-shadow: 0px 0px 3px rgba(127, 130, 139, 0.53);
  }

  .badge {
    align-self: center;
    display: flex;
    margin-right: 0.3em;
    background-color: white;
    border-radius: 5px;
    height: 20px;
    align-items: center;
    padding: 0.2em;
  }

  .badge img {
    width: 15px;
    height: 15px !important;
  }

  .counters {
    display: flex;
    top: 263px;
    left: 1em;
    position: absolute;
  }

  .item_context_menu {
    position: absolute;
    top: 200px;
    width:280px;
    margin-right: -2.4em;
    z-index: 130;
  }

  .wantit {
    background-color: white;
    color: #b53a44;
    border: 1px solid #b53a44;
    border-radius: 2px;
    width: 90px;
  }

</style>
